var _style, _path, _rect, _defs, _g, _defs2, _g2, _g3, _polygon, _g4, _path2, _ellipse, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppMarketplace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 379 320",
    style: {
      enableBackground: "new 0 0 379 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0EFEF;}\n\t.st1{fill:none;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{clip-path:url(#SVGID_4_);}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#00A2E1;}\n\t.st6{enable-background:new    ;}\n\t.st7{fill:url(#Trac\xE9_206_1_);}\n\t.st8{fill:#E0E2E5;}\n\t.st9{fill:url(#Trac\xE9_208_1_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "img-app-marketplace",
    transform: "translate(-928 -313)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_174",
    className: "st0",
    d: "M1150.8,392.4l41.9-41.9c26.1-25.7,68.1-25.4,93.8,0.7c25.4,25.8,25.4,67.3,0,93.1 l-127.1,127.1c-25.9,25.9-67.9,25.9-93.8,0l0,0l0,0c-25.9-25.9-25.9-67.9,0-93.8L1150.8,392.4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_832",
    x: 1046.3,
    y: 331,
    className: "st1",
    width: 259.7,
    height: 259.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1181",
    transform: "translate(493 175)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 715.3,
    y: 318.7,
    width: 89.6,
    height: 89.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1180",
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_175",
    className: "st0",
    d: "M722,369.2l43.8-43.8c8.9-8.9,23.4-8.9,32.4,0.1c8.9,8.9,8.9,23.4,0,32.3l-43.8,43.8 c-8.9,8.9-23.4,8.9-32.4-0.1C713.1,392.6,713.1,378.1,722,369.2"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1184",
    transform: "translate(493 175)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 436.2,
    y: 295,
    width: 89.6,
    height: 89.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1183",
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_176",
    className: "st0",
    d: "M519.1,334l-43.8,43.8c-9,8.9-23.5,8.8-32.4-0.2c-8.8-8.9-8.8-23.3,0-32.2l43.8-43.8 c8.9-8.9,23.4-8.9,32.4,0C528,310.6,528,325.1,519.1,334"
  }))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 493, 313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_202-2",
    className: "st4",
    d: "M493.9,31.9h260.8c3.8,0,6.9,3.1,6.9,6.9v243.4c0,3.8-3.1,6.9-6.9,6.9H493.9 c-3.8,0-6.9-3.1-6.9-6.9V38.9C487,35,490.1,31.9,493.9,31.9z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1128.3,561.3 1116.7,572.9 1116.7,552.5 1114.8,552.5 1114.8,572.9 1103.1,561.3 1101.8,562.6  1115.7,576.5 1129.6,562.6  "
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1199",
    transform: "translate(493 175)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1198"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M548.4,352.8l2.9-5.5h2.2l-4,7.4v4.7h-2v-4.6l-4-7.5h2.2L548.4,352.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M561.9,359.4H555v-12.1h6.9v1.7H557v3.3h4.6v1.7H557v3.8h4.9V359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M569.8,359.4l-3.5-10.1h-0.1c0.1,1.5,0.1,2.9,0.1,4.2v5.9h-1.8v-12.1h2.8l3.4,9.7l0,0l3.5-9.7h2.8v12.1 h-1.9v-6c0-0.6,0-1.4,0-2.4s0.1-1.6,0.1-1.8h-0.1l-3.6,10.1L569.8,359.4L569.8,359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M589.9,359.4l-3.5-10.1h-0.1c0.1,1.5,0.1,2.9,0.1,4.2v5.9h-1.8v-12.1h2.8l3.4,9.7l0,0l3.5-9.7h2.8v12.1 h-1.9v-6c0-0.6,0-1.4,0-2.4s0.1-1.6,0.1-1.8h-0.1l-3.6,10.1L589.9,359.4L589.9,359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M607.9,359.4l-1.2-3.4H602l-1.2,3.4h-2.1l4.5-12.2h2.2l4.5,12.2H607.9z M606.2,354.3L605,351 c-0.1-0.2-0.2-0.6-0.3-1c-0.1-0.5-0.2-0.8-0.3-1c-0.1,0.7-0.4,1.4-0.7,2.2l-1.1,3.2h3.6V354.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M613.6,354.5v4.8h-2v-12.1h3.4c1.6,0,2.7,0.3,3.5,0.9s1.1,1.5,1.1,2.7c0,1.5-0.8,2.6-2.4,3.2l3.4,5.4 h-2.3l-2.9-4.8h-1.8V354.5z M613.6,352.9h1.4c0.9,0,1.6-0.2,2-0.5s0.6-0.9,0.6-1.5c0-0.7-0.2-1.2-0.7-1.5s-1.1-0.4-2-0.4 h-1.3V352.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M631.7,359.4h-2.3l-3.8-5.5l-1.2,1v4.5h-2v-12.1h2v5.8c0.5-0.7,1.1-1.3,1.6-1.9l3.3-3.9h2.3 c-2.1,2.5-3.6,4.3-4.6,5.3L631.7,359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M640.2,359.4h-6.9v-12.1h6.9v1.7h-4.9v3.3h4.6v1.7h-4.6v3.8h4.9V359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M647,359.4h-2V349h-3.6v-1.7h9.1v1.7H647V359.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M660.5,350.9c0,1.3-0.4,2.2-1.2,2.9c-0.8,0.7-2,1-3.5,1h-1.3v4.5h-2v-12.1h3.5c1.5,0,2.7,0.3,3.4,0.9 C660.1,348.8,660.5,349.7,660.5,350.9z M654.4,353.2h1.1c1,0,1.8-0.2,2.2-0.5c0.5-0.4,0.7-0.9,0.7-1.7c0-0.7-0.2-1.2-0.6-1.6 s-1.1-0.5-2-0.5h-1.4V353.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M662.9,359.4v-12.1h2v10.4h5.1v1.7H662.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M679.6,359.4l-1.2-3.4h-4.6l-1.2,3.4h-2.1l4.5-12.2h2.2l4.5,12.2H679.6z M677.9,354.3l-1.1-3.3 c-0.1-0.2-0.2-0.6-0.3-1s-0.2-0.8-0.3-1c-0.1,0.7-0.4,1.4-0.7,2.2l-1.1,3.2h3.5L677.9,354.3L677.9,354.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M688.5,348.8c-1.1,0-2,0.4-2.7,1.2c-0.7,0.8-1,1.9-1,3.3c0,1.5,0.3,2.6,0.9,3.4s1.5,1.1,2.7,1.1 c0.5,0,1-0.1,1.5-0.2s1-0.2,1.5-0.4v1.7c-1,0.4-2,0.5-3.2,0.5c-1.8,0-3.1-0.5-4.1-1.6s-1.4-2.6-1.4-4.6 c0-1.3,0.2-2.4,0.7-3.3s1.1-1.7,2-2.2s1.9-0.8,3.1-0.8c1.2,0,2.4,0.3,3.4,0.8l-0.7,1.7c-0.4-0.2-0.8-0.4-1.3-0.5 C689.5,348.8,689,348.8,688.5,348.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M701,359.4h-6.9v-12.1h6.9v1.7h-4.9v3.3h4.6v1.7h-4.6v3.8h4.9V359.4z"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_1_"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trac\\xE9_206_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2206.6638,
    y1: 40.1982,
    x2: 2207.3936,
    y2: 39.7242,
    gradientTransform: "matrix(88.976 0 0 -104.5828 -195258.375 4611.2466)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ABE7FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    style: {
      stopColor: "#5CD0FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    style: {
      stopColor: "#13A4DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1099D1"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_206",
    className: "st7",
    d: "M1161.8,432.5c0,24.6-44.5,59.9-44.5,59.9s-44.5-35.3-44.5-59.9 c-0.1-24.6,19.7-44.6,44.3-44.7c24.6-0.1,44.6,19.7,44.7,44.3C1161.8,432.2,1161.8,432.3,1161.8,432.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_22",
    className: "st4",
    cx: 1117.3,
    cy: 431.3,
    rx: 25.1,
    ry: 25.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_207",
    className: "st8",
    d: "M1136,414.4c0,0-17.3-4-28.4,6.1c-15.1,13.9-8.8,27.6-8.8,27.6c-9.3-10.3-8.5-26.2,1.8-35.5 S1126.7,404.1,1136,414.4L1136,414.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Trac\\xE9_208_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2221.7915,
    y1: 35.8345,
    x2: 2220.6694,
    y2: 36.5185,
    gradientTransform: "matrix(28.6295 0 0 -32.7181 -62467.7852 1620.0726)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#66D4FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#11A3DE"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_208",
    className: "st9",
    d: "M1117.5,447.6c-9,0-16.4-7.3-16.4-16.3s7.3-16.4,16.3-16.4c4.7,0,9.2,2,12.3,5.5l-3.6,3.2 c-4.2-4.7-11.5-5.2-16.2-1c-0.8,0.7-1.5,1.6-2.1,2.5h11.6v4.9h-13.2c0,0.4-0.1,0.8-0.1,1.2c0,0.6,0,1.1,0.1,1.7h13.2v4.9h-11.2 c3.6,5.2,10.8,6.5,16,2.8c0.5-0.3,0.9-0.7,1.3-1.1l3.4,3.5C1125.7,446,1121.7,447.6,1117.5,447.6z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppMarketplace);
export default __webpack_public_path__ + "static/media/app-marketplace.7f8d89415273d8025185969a84603139.svg";
export { ForwardRef as ReactComponent };